import { useCallback } from "react";
import { useHistory } from "react-router-dom";

import { ClipContext } from "MVVM/Views/ClipExperience/@types";

export const useClipNavigate = () => {
  const history = useHistory();

  const navigateToClip = useCallback(
    (clipId: string, context?: ClipContext) => {
      const pathname = `/clip/${clipId}`;

      history.push({
        pathname,
        state: { autoplay: true, referrer: window.location.pathname, context },
      });
    },
    [history],
  );

  return { navigateToClip };
};
